import Axios from "axios";
import { APIBASE_URL, TRADE_URL } from "../config/cacheKey";
import { ApiResultModel } from "../models/common.model";
import { IConvertToAssetRequest, IConvertToAssetResponse, IGetExchangeRateRequest, IGetExchangeRateResponse, IGetTotalCreditForAssetConvertResponse, IGetTradeHistoriesResponse, TGetTradeFaqsResponse } from "../models/trade.model";

export const GetExchangeRate = (data: IGetExchangeRateRequest): Promise<IGetExchangeRateResponse> => {
    return Axios.post<ApiResultModel<IGetExchangeRateResponse>>(
        APIBASE_URL + TRADE_URL + '/GetExchangeRate',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const ConvertToAsset = (data: IConvertToAssetRequest): Promise<IConvertToAssetResponse> => {
    return Axios.post<ApiResultModel<IConvertToAssetResponse>>(
        APIBASE_URL + TRADE_URL + '/ConvertToAsset',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetTradeHistories = (): Promise<IGetTradeHistoriesResponse[]> => {
    return Axios.get<ApiResultModel<IGetTradeHistoriesResponse[]>>(
        APIBASE_URL + TRADE_URL + '/GetTradeHistories',

    ).then((result) => {
        return result.data.data;
    });
};

export const GetTotalCreditForAssetConvert = (): Promise<IGetTotalCreditForAssetConvertResponse> => {
    return Axios.get<ApiResultModel<IGetTotalCreditForAssetConvertResponse>>(
        APIBASE_URL + TRADE_URL + '/GetTotalCreditForAssetConvert',

    ).then((result) => {
        return result.data.data;
    });
};
export const GetTradeFaqs = (): Promise<TGetTradeFaqsResponse> => {
    return Axios.get<ApiResultModel<TGetTradeFaqsResponse>>(
        APIBASE_URL + TRADE_URL + '/GetTradeFaqs',

    ).then((result) => {
        return result.data.data;
    });
};









